export const NAME = 'cp:open-panel'


export default function createEvent() {
    return new CustomEvent(NAME, {
        bubbles: true,
        composed: true,
    })
}
